import React from "react";
import {
  ShieldCheck, ShieldAlert, HeartPulse, Flame, Wrench,
  AlertCircle, AlertTriangle, AlertOctagon, Info,
} from "lucide-react";

export const TEAM_META = {
  security:   { label: "Security",   icon: ShieldAlert, color: "hsl(var(--primary))" },
  police:     { label: "Police",     icon: ShieldCheck, color: "hsl(217 91% 60%)" },
  medical:    { label: "Medical",    icon: HeartPulse,  color: "hsl(var(--destructive))" },
  fire:       { label: "Fire",       icon: Flame,       color: "hsl(var(--warning))" },
  facilities: { label: "Facilities", icon: Wrench,      color: "hsl(var(--muted-foreground))" },
};

export const STATUS_META = {
  new:        { label: "New",         color: "hsl(var(--muted-foreground))" },
  ack:        { label: "Acknowledged", color: "hsl(var(--primary))" },
  dispatched: { label: "Dispatched",   color: "hsl(var(--warning))" },
  resolved:   { label: "Resolved",     color: "hsl(var(--success))" },
  reviewed:   { label: "Reviewed",     color: "hsl(var(--muted-foreground))" },
};

export const SEVERITY_META = {
  critical: { icon: AlertOctagon, className: "sev-critical" },
  high:     { icon: AlertTriangle, className: "sev-high" },
  medium:   { icon: AlertCircle,   className: "sev-medium" },
  low:      { icon: Info,          className: "sev-low" },
};

export const fmtRel = (iso) => {
  if (!iso) return "—";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return `${Math.max(1, Math.floor(diff))}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

export const fmtDuration = (sec) => {
  if (sec == null) return "—";
  if (sec < 60) return `${Math.round(sec)}s`;
  const m = Math.floor(sec / 60);
  if (m < 60) return `${m}m ${Math.round(sec - m * 60)}s`;
  const h = Math.floor(m / 60);
  return `${h}h ${m - h * 60}m`;
};

export const SeverityChip = ({ sev }) => {
  const map = {
    critical: "bg-sev-critical",
    high: "bg-sev-high",
    medium: "bg-sev-medium",
    low: "bg-sev-low",
  };
  const label = sev ? sev.charAt(0).toUpperCase() + sev.slice(1) : "—";
  return (
    <span className={`px-1.5 py-0.5 text-[10px] font-bold tracking-wide ${map[sev] || "bg-sev-low"}`}>
      {label}
    </span>
  );
};

export const StatusChip = ({ status }) => {
  const meta = STATUS_META[status] || STATUS_META.new;
  return (
    <span
      className="px-1.5 py-0.5 text-[10px] font-bold tracking-wide border"
      style={{ color: meta.color, borderColor: meta.color }}
    >
      {meta.label}
    </span>
  );
};

export const TeamChip = ({ team }) => {
  const meta = TEAM_META[team] || TEAM_META.security;
  const Icon = meta.icon;
  return (
    <span className="inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-bold tracking-wide border border-border" style={{ color: meta.color }}>
      <Icon className="w-3 h-3" /> {meta.label}
    </span>
  );
};
